import { useAuth0 } from '@auth0/auth0-react'
import { Box, CircularProgress, Typography, Stack } from '@mui/material'
import { DIALOGS } from '~/components/Charts/chrome/chartChrome'

export function Callback() {
  const { error } = useAuth0()
  if (error) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography color="error">{error.message}</Typography>
      </Box>
    )
  }
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <Stack spacing={2} alignItems="center">
        <CircularProgress />
        <Typography>{DIALOGS.signingIn}</Typography>
      </Stack>
    </Box>
  )
}
